import {BaseService} from "./BaseService";
import {ServerStatus} from "../entities/ServerStatus";
import { StateService } from "@uirouter/angularjs";

export class ServerStatusService extends BaseService<ServerStatus>{
    static $inject = ['$http','$q','$state'];
    constructor($http: ng.IHttpService, $q: ng.IQService, $state: StateService) {
        super($http, $q, $state, ServerStatus);
    }
    protected getBaseUrl():string{
        return "serverstatus";
    }
    protected getBasesUrl():string{
      return "serverstatuses";
    }
    public getActiveServers(){
        var config:any = {};
        return this.useGetHandler(this.getBasesUrl(),"active", config);
    }
    chirpstackConnected():ng.IPromise<boolean> {
        var config:any = {};
        return this.useGetHandler(this.getBaseUrl(),'Chirpstack', config);
    }
}
